module.exports = __webpack_public_path__ + "static/media/GirlWithStar.a235b1b7.svg";